import React from 'react';
import Box from 'fe-design-base/atoms/Box';
import CheckboxField from 'fe-design-base/molecules/CheckboxField';
import PropTypes from 'prop-types';

import {
  FORM_WITH_STEPS_BOX_STYLE,
  I18N_PAYROLL_PATH,
} from 'features/team/components/AddEmployeeForm/constants';

import { cxHelpers } from 'util/className';
import { toI18n } from 'util/i18n';

import SectionTitle from '../../components/SectionTitle';
import TaxClassification from '../../components/TaxClassification';
const { cx } = cxHelpers('PayrollSection');
const PayrollSection = ({ showFormWithSteps }) => (
  <Box
    className={cx()}
    mv={28}
    {...(showFormWithSteps && FORM_WITH_STEPS_BOX_STYLE)}
  >
    <SectionTitle section="payroll" topBorder />
    <Box mt={24}>
      <CheckboxField
        name="includedInPayroll"
        label={toI18n(`${I18N_PAYROLL_PATH}.include_in_payroll`)}
      />
    </Box>
    <TaxClassification />
  </Box>
);

PayrollSection.propTypes = {
  showFormWithSteps: PropTypes.bool,
};

export default PayrollSection;
